import React from 'react';
import { ModalStateProvider } from '../../model/modelState';
import ActionsDropdown from '../ActionsDropdown/ActionsDropdown';
import ModalFactory from '../ModalFactory/ModalFactory';
import { SelectedParamProvider } from '../../model/modalParam';

const MainComponent = ({ flats }) => {
  return (
    <ModalStateProvider>
      <SelectedParamProvider>
        <ActionsDropdown />
        <ModalFactory flats={flats} />
      </SelectedParamProvider>
    </ModalStateProvider>
  );
};

export default MainComponent;
